{
    "dEC1I": {
        "position": {
            "x": 4,
            "y": 5,
            "z": 1
        },
        "key": "dEC1I",
        "tag": "wall",
        "hasCollision": true
    },
    "A4-Nz": {
        "position": {
            "x": 4,
            "y": 6,
            "z": 1
        },
        "key": "A4-Nz",
        "tag": "wall",
        "hasCollision": true
    },
    "GGLx5": {
        "position": {
            "x": 6,
            "y": 3,
            "z": 1
        },
        "key": "GGLx5",
        "tag": "wall",
        "hasCollision": true
    },
    "Sr4xO": {
        "position": {
            "x": 8,
            "y": 4,
            "z": 1
        },
        "key": "Sr4xO",
        "tag": "wall",
        "hasCollision": true
    },
    "1PTNZ": {
        "position": {
            "x": 11,
            "y": 4,
            "z": 1
        },
        "key": "1PTNZ",
        "tag": "wall",
        "hasCollision": true
    },
    "MVxQO": {
        "position": {
            "x": 10,
            "y": 7,
            "z": 1
        },
        "key": "MVxQO",
        "tag": "wall",
        "hasCollision": true
    },
    "eqUAm": {
        "position": {
            "x": 7,
            "y": 8,
            "z": 1
        },
        "key": "eqUAm",
        "tag": "wall",
        "hasCollision": true
    },
    "WV5oJ": {
        "position": {
            "x": 6,
            "y": 8,
            "z": 1
        },
        "key": "WV5oJ",
        "tag": "wall",
        "hasCollision": true
    },
    "HEzPp": {
        "position": {
            "x": 5,
            "y": 7,
            "z": 1
        },
        "key": "HEzPp",
        "tag": "wall",
        "hasCollision": true
    },
    "JYLqO": {
        "position": {
            "x": 8,
            "y": 8,
            "z": 1
        },
        "key": "JYLqO",
        "tag": "wall",
        "hasCollision": true
    },
    "InXMn": {
        "position": {
            "x": 7,
            "y": 4,
            "z": 1
        },
        "key": "InXMn",
        "tag": "wall",
        "hasCollision": true
    },
    "qJ_Fx": {
        "position": {
            "x": 11,
            "y": 5,
            "z": 1
        },
        "key": "qJ_Fx",
        "tag": "wall",
        "hasCollision": true
    },
    "2PIn4": {
        "position": {
            "x": 10,
            "y": 3,
            "z": 1
        },
        "key": "2PIn4",
        "tag": "wall",
        "hasCollision": true
    },
    "AZhuM": {
        "position": {
            "x": 9,
            "y": 3,
            "z": 1
        },
        "key": "AZhuM",
        "tag": "wall",
        "hasCollision": true
    },
    "gKEWY": {
        "position": {
            "x": 11,
            "y": 6,
            "z": 1
        },
        "key": "gKEWY",
        "tag": "wall",
        "hasCollision": true
    },
    "dU_-1": {
        "position": {
            "x": 9,
            "y": 7,
            "z": 1
        },
        "key": "dU_-1",
        "tag": "wall",
        "hasCollision": true
    },
    "uFgDP": {
        "position": {
            "x": 4,
            "y": 4,
            "z": 1
        },
        "key": "uFgDP",
        "tag": "wall",
        "hasCollision": true
    },
    "zKEgg": {
        "position": {
            "x": 5,
            "y": 3,
            "z": 1
        },
        "key": "zKEgg",
        "tag": "wall",
        "hasCollision": true
    }
}